
import { Component, Prop, Vue } from 'vue-property-decorator';
import CommentRepositoryInterface from '@/services/QA/comment/interfaces';
import NoteRepositoryInterface from '@/services/QA/note/interfaces';

@Component({
  inject: [
    'noteRepository',
  ],
})
export default class DeleteNoteDialog extends Vue {
  @Prop() private readonly noteId!: number;
  private noteRepository!: NoteRepositoryInterface;
  private visible: boolean = true;

  get message(): string {
    return `Are you sure you want to delete the note?`;
  }

  private async deleteNote(): Promise<void> {
    try {
      await this.noteRepository.deleteNote(this.noteId);
      this.$successDialog.show('Note Deleted');
      this.$emit('noteDeleted', this.noteId)
      this.destroyComponent();
    } catch (e) {
      this.$errorDialog.show(e.response?.data?.message);
    }
  }

  private destroyComponent(): void {
    this.$emit('close');
  }
}
